import { State } from '@/app/state/model';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { selectPPTBillDelegated, selectPPTBillDependenciesDelegated, selectPPTBillOrDependenciesDelegated } from '../state/entities/bill/ppt-bill.selectors';
import { selectDelegatedBillMessage, selectDelegatedPriorsMessage } from '../state/ppt-state/ppt-state.selectors';

@Injectable({ providedIn: 'any' })
export class PPTDelegated
{
    constructor
    (
        private readonly store: Store<State>
    )
    {}


    public billDelegated$(billId: string | undefined)
    {
        return billId
            ? this.store.select(selectPPTBillDelegated(billId))
            : of(undefined);
    }

    private dependenciesDelegated$(billId: string | undefined)
    {
        return billId
            ? this.store.select(selectPPTBillDependenciesDelegated(billId))
            : of(undefined);
    }

    public billOrDepsDelegated$(billId: string | undefined)
    {
        return billId
            ? this.store.select(selectPPTBillOrDependenciesDelegated(billId))
            : of(undefined);
    }

    public delegatedMessage$(billId: string | undefined)
    {
        return this.billDelegated$(billId).pipe(
            switchMap(delegated => delegated === undefined
                ? of(delegated)
                : delegated
                    ? this.store.select(selectDelegatedBillMessage)
                    : this.dependenciesDelegated$(billId).pipe(
                        switchMap(depsDelegated => depsDelegated
                            ? this.store.select(selectDelegatedPriorsMessage)
                            : of(null)
                        )
                    )
            )
        );
    }
}
